import { render } from "./BaseTableIncludableData.vue?vue&type=template&id=5d6b74d4&scoped=true"
import script from "./BaseTableIncludableData.vue?vue&type=script&lang=js"
export * from "./BaseTableIncludableData.vue?vue&type=script&lang=js"

import "./BaseTableIncludableData.vue?vue&type=style&index=0&id=5d6b74d4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6b74d4"]])

export default __exports__